import { capitalize } from 'vue';

import CreativeType from '@/common/enums/CreativeType.enum';
import { IOption } from '@/common/models/Option';
import i18n from '@/vueI18n';

class CreativeTypeOptions {
  static options(): IOption[] {
    return [
      {
        value: CreativeType.Audio,
        name: capitalize(i18n.global.t('options.creativeType.audio')),
      },
      {
        value: CreativeType.Banner,
        name: capitalize(i18n.global.t('options.creativeType.banner')),
      },
      {
        value: CreativeType.Native,
        name: capitalize(i18n.global.t('options.creativeType.native')),
      },
      {
        value: CreativeType.Video,
        name: capitalize(i18n.global.t('options.creativeType.video')),
      },
    ];
  }
  static displayVideoOptions(): IOption[] {
    return [
      {
        value: CreativeType.Banner,
        name: capitalize(i18n.global.t('options.creativeType.banner')),
      },
      {
        value: CreativeType.Video,
        name: capitalize(i18n.global.t('options.creativeType.video')),
      },
    ];
  }
}

export default CreativeTypeOptions;
